import React, { useState } from 'react';
import { useEffect } from 'react';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import { useDispatch } from 'react-redux';
import TaskDialog from '../tasks/TaskDialog';
import { intialPageSize, taskComplete } from 'constants';
import { getTaskListData, taskColumns } from '../tasks/TasksDataGrid';
import { getTaskForm } from 'layouts/taskManagement/store/taskSlice/taskSlice';
import {
  getDataGridHeading,
  useResetSnackbar,
  useNotification,
  onSave,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import {
  getTask,
  getActiveTasks,
  postMarkInComplete,
  postMarkComplete,
} from 'layouts/taskManagement/services/taskManagementApi';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';

const ActiveTaskList = () => {
  useResetSnackbar();
  const dispatch = useDispatch();
  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();
  const [openTaskDialog, setOpenTaskDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [taskCompletedLoading, setTaskCompletedLoading] = useState(false);
  const [loadingRowId, setLoadingRowId] = useState(null);

  const [activeTaskList, setActiveTaskList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
  });

  useEffect(() => {
    fetchActiveTasks();
  }, []);

  const fetchActiveTasks = async () => {
    setActiveTaskList({ ...activeTaskList, isLoading: true });
    try {
      const activeTasks = await getActiveTasks();
      setActiveTaskList({ ...activeTaskList, isLoading: false });
      setActiveTaskList((prev) => ({
        ...prev,
        rows: getTaskListData(activeTasks),
      }));
    } catch (error) {
      setOpenNotification(true);
      setNotificationMessage(error?.response?.data?.message);
      setActiveTaskList({ ...activeTaskList, isLoading: false });
    }
  };

  const updateTask = async (params) => {
    const { row } = params;
    setIsLoading(true);
    const task = await getTask(row.id);
    dispatch(getTaskForm(task));
    setIsLoading(false);
    setOpenTaskDialog(true);
  };

  const handleClose = () => {};

  const handleTaskCompleted = async (params) => {
    setLoadingRowId(params.row.id);
    const { row } = params;
    onSave(
      taskComplete,
      row.completed,
      postMarkInComplete,
      postMarkComplete,
      row.id,
      '',
      fetchActiveTasks,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setTaskCompletedLoading,
      taskCompletedLoading
    );
  };

  const pageSizeChange = pageSizeChangeHandler(setActiveTaskList);

  return (
    <>
      <MDBox>
        <Card>
          {getDataGridHeading('Active Tasks')}
          <DeltaDataGrid
            listData={activeTaskList}
            columns={taskColumns(
              updateTask,
              handleTaskCompleted,
              taskCompletedLoading,
              loadingRowId
            )}
            setListData={pageSizeChange}
          />
        </Card>
      </MDBox>
      <TaskDialog
        open={openTaskDialog}
        setOpen={setOpenTaskDialog}
        fetchTasks={fetchActiveTasks}
        isLoading={isLoading}
      />
      <NotificationPopup />
    </>
  );
};

export default ActiveTaskList;
